import '../instruments.ts';

import { loadVanillaTranslations } from '@utils/vanillaTranslations';

import { MUI_LICENSE_KEY } from '@constants/common.js';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LicenseInfo } from '@mui/x-license';
import * as Sentry from '@sentry/react';
import { gtmService } from '@utils/gtm.js';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Error } from 'src/routes/Error.js';
import { App } from './App.js';
import './index.less';
import { store } from './store/store';
import './tailwind.css';
import { theme } from './theme.js';

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

// Initialize Google Tag Manager only if container ID is present
gtmService.initialize();

const Root = () => {
    const [vanillaMessages, setVanillaMessages] = useState<Record<string, string>>({});

    useEffect(() => {
        loadVanillaTranslations()
            .then(setVanillaMessages)
            .catch((err) => {
                console.error('Failed to load messages:', err);
            });
    }, []);

    return (
        <React.StrictMode>
            <Sentry.ErrorBoundary fallback={<Error useVanillaComponents messages={vanillaMessages} />}>
                <BrowserRouter>
                    <Provider store={store}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <StyledEngineProvider injectFirst>
                                <ThemeProvider theme={theme}>
                                    <App />
                                </ThemeProvider>
                            </StyledEngineProvider>
                        </LocalizationProvider>
                    </Provider>
                </BrowserRouter>
            </Sentry.ErrorBoundary>
        </React.StrictMode>
    );
};

ReactDOM.createRoot(document.getElementById('root')!).render(<Root />);
